// extracted by mini-css-extract-plugin
module.exports = {"positioner":"FlexScroll_positioner__2D0xM","scrollContainer":"FlexScroll_scrollContainer__2WJoa"};